import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";
import {v4 as uuid} from 'uuid';

const hiddenInput = tokenDefinition({
  name: TokenName.HIDDEN_INPUT,
  type: TokenType.DELIMITER,
  tokenMatcher: /^(?<!-)---(?!-)/,
  contentMatcher: /^(?<!-)---(?!-)/
});


class HiddenInput {

  constructor() {
    this.length = 0
  }

  consume(tokenIterator, nodeIterator) {

    if(this.isHiddenInput(tokenIterator)) {
      this.openNewNode(tokenIterator, nodeIterator)
    }
  }

  onEndOfMarkup(openNode) {
    openNode.cancel()
  }

  toHtml(node, toHtml, idProvider) {
    // build the hidden input at once, toHtml callback is not used
    const correction = node.children[0].value
    const id = idProvider.next()

    return `<span class='hidden-input' id='hidden-input__${id}'>
      <input type='text' class='answer'/><span class='correction'>${correction}</span>
    </span>`
  }

  isHiddenInput(tokenIterator) {
    // match only closed hidden input containing only plain text
    // TODO handle line feed for multiline hidden input like dictation
    return tokenIterator.hasNext(3)
        && tokenIterator.token().name === TokenName.HIDDEN_INPUT
        && tokenIterator.peekNext(1).name === TokenName.CHARACTER_LITERAL
        && tokenIterator.peekNext(2).name === TokenName.HIDDEN_INPUT
  }

  openNewNode(tokenIterator, nodeIterator) {
    const hiddenNode = new Node(
        NodeName.HIDDEN_INPUT,
        null,
        new HiddenInput(),
        nodeIterator.currentParentNode
    )

    const hiddenContentNode = new Node(
        NodeName.TEXT,
        tokenIterator.peekNext(1).value,
        null,
        hiddenNode
    )

    hiddenNode.addChildren([hiddenContentNode])

    nodeIterator.addClosedNode(hiddenNode)
    tokenIterator.eatTokens(3)

  }

}

export {hiddenInput, HiddenInput}
